module.exports = __webpack_public_path__ + "static/media/ic_chat_blue.7febe5a7.png";